import React from 'react';

import CircularProgress from '@mui/material/CircularProgress';
import {
  SpaceProps,
  TypographyProps,
  PositionProps,
  LayoutProps,
  BorderProps,
  ColorProps,
} from 'styled-system';
import { StyledIcon } from 'components/Common/Icon/style';

export type IconType = SpaceProps &
  PositionProps &
  LayoutProps &
  BorderProps &
  ColorProps &
  TypographyProps & {
    name?: string;
    loading?: boolean;
    disabled?: boolean;
    color?: string;
    onClick?: () => void;
  };

const Icon: React.FC<IconType> = ({ name, loading, ...rest }) =>
  loading ? (
    <StyledIcon {...rest}>
      <CircularProgress
        size={12}
        sx={{ color: 'inherit', fontSize: 'inherit' }}
      />
    </StyledIcon>
  ) : (
    <StyledIcon className={`icon-${name}`} {...rest} />
  );

export default Icon;
